import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { color } from "../../../StyleData/Config";
import { Clear } from "@mui/icons-material";
import NormalTable from "../../../Component/NormalTable";

const WorkCenterView = ({ data, handleCloseClick }) => {
  const labourColumns = [
    { Header: "Labour Name", accessor: "labourName", Cell: ({ cell }) => cell.value || "-" },
    {
      Header: "Craft Name",
      accessor: "craftList",
      Cell: ({ cell }) => {
        const craftList = cell.value;
        if (Array.isArray(craftList) && craftList.length > 0) {
          return craftList.map(craft => craft.craftName).join(", ");
        }
        return "-";
      }
    },
  ];

  const businessColumns = [
    { Header: "Business Name", accessor: "businessName", Cell: ({ cell }) => cell.value || "-" },
    {
      Header: "Craft Name",
      accessor: "craftList",
      Cell: ({ cell }) => {
        const craftList = cell.value;
        if (Array.isArray(craftList) && craftList.length > 0) {
          return craftList.map(craft => craft.craftName).join(", ");
        }
        return "-";
      }
    },
  ];

  let responsiblePerson = "-";
  if (Array.isArray(data?.responsiblePersonList) && data.responsiblePersonList.length > 0) {
    responsiblePerson = data.responsiblePersonList.map(p => p.name).join(", ");
  }

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {data?.code && data?.workCenterName
            ? `${data.code} - ${data.workCenterName}`
            : data?.code || data?.workCenterName || "Work Center Details"}
        </Typography>
        <IconButton onClick={handleCloseClick}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontWeight: 600 }}>Work Center Code</Typography>
          <Typography>{data?.code || "-"}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontWeight: 600 }}>Work Center Name</Typography>
          <Typography>{data?.workCenterName || "-"}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontWeight: 600 }}>Description</Typography>
          <Typography>{data?.description || "-"}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontWeight: 600 }}>Responsible Person</Typography>
          <Typography>{responsiblePerson}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 600, mb: 1 }}>Labour List</Typography>
          <NormalTable
            data={Array.isArray(data?.labourList) ? data.labourList : []}
            columns={labourColumns}
            filt={false}
            showPagination={false}
            showSearch={false}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 600, mb: 1 }}>Business List</Typography>
          <NormalTable
            data={Array.isArray(data?.businessList) ? data.businessList : []}
            columns={businessColumns}
            filt={false}
            showPagination={false}
            showSearch={false}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default WorkCenterView;

